import React, { useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { sendCommand } from "../../../util/util";
import AppContext from "../../Context/AppContext";
import { Navbar, Button, RoomNavbarContainer, Title, Token } from "../style";

const TokenNavbar = ({ history }) => {
  const {
    room,
    websocket,
    members,
    setIsGameStarter,
    setUsername,
    setChatList,
    setMembers,
    setIsStarted,
    setRole,
    setTurn,
    setIsDead,
  } = useContext(AppContext);

  const onClose = () => {
    let jsonMessage = JSON.stringify({ command: "kill_room", arg: "" });
    websocket.send(jsonMessage);
    history.push("/");
  };

  const onStart = () => {
    sendCommand(websocket, "assign");
    sendCommand(websocket, "start");
    setIsGameStarter(true);
  };

  const clean = () => {
    setUsername("");
    setChatList([]);
    setMembers([]);
    setIsStarted(false);
    setRole("");
    setTurn("");
    setIsDead(false);
  };

  useEffect(() => {
    if (websocket !== null && websocket !== undefined) {
      websocket.onclose = () => {
        clean();
        history.push("/");
        alert("Room Closed!");
      };
    } else {
      history.push("/");
    }
  });

  return (
    <Navbar>
      <Button onClick={onClose}>Close</Button>
      <RoomNavbarContainer>
        <Title>Werewolf</Title>
        <Token>Room: {room}</Token>
      </RoomNavbarContainer>
      {members.length >= 2 ? (
        <Button onClick={onStart}>Start</Button>
      ) : (
        <Button disabled>Start</Button>
      )}
    </Navbar>
  );
};

export default withRouter(TokenNavbar);
